import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';

import { BaseComponentClassDirective } from '~shared/classes/base-component.class';
import { IAddress } from '~shared/modules/addresses/models/address.model';
import { PageService } from '~shared/services/page.service';
import { ADDRESS_ACTION_TYPE } from '../../constants/address-actions.constant';
import { IAddressData } from '../../models/address-data.model';
import { AddressBookService } from '../../services/address-book.service';
import { AddressBookUtil } from '../../utils/address-book.util';

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.scss']
})
export class AddressesComponent extends BaseComponentClassDirective implements OnInit {
  public templateOptions: { addressData$: Observable<IAddressData[]> } = {
    addressData$: null,
  };

  constructor (
    private addressBookService: AddressBookService,
    private pageService: PageService,
  ) {
    super();
  }

  public ngOnInit(): void {
    this.templateOptions.addressData$ = this.addressBookService.getAddressList().pipe(
      map((addresses: IAddress[]) => addresses.map(
        (address: IAddress) => AddressBookUtil.createAddressData(address)
      )),
      takeUntil(this.unsubscribe$),
    );
  }

  public onActionClick(event) {
    switch (event.type) {
      case ADDRESS_ACTION_TYPE.setDefaultShipping:
        this.setAsDefaultShipping(event.target);
        break;

      case ADDRESS_ACTION_TYPE.setDefaultBilling:
        this.setAsDefaultBilling(event.target);
        break;

      case ADDRESS_ACTION_TYPE.update:
        this.navigateToChangeAddress(event.target);
        break;

      case ADDRESS_ACTION_TYPE.remove:
        this.deleteAddress(event.target);
        break;
    }
  }

  private setAsDefaultBilling(address: IAddress): void {
    this.updateAddress({ ...address, defaultBilling: true });
  }

  private setAsDefaultShipping(address: IAddress): void {
    this.updateAddress({ ...address, defaultShipping: true });
  }

  private navigateToChangeAddress(address: IAddress): void {
    this.pageService.navigateByPageAlias('edit-address', {
      queryParams: {
        id: address.id,
      },
    });
  }

  private deleteAddress(address: IAddress): void {
    this.addressBookService.showDeleteAddressPopup(address.id);
  }

  private updateAddress(updatedAddress: IAddress): void {
    this.addressBookService.updateAddress(updatedAddress, true).pipe(
      take(1)
    ).subscribe();
  }
}
